var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69 5.582L16.282 1l2.536 4.594L8.69 5.582v0z",
    stroke: "#FC500E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.75c0-.305.116-.597.322-.813.206-.216.486-.337.778-.337h19.8c.292 0 .572.121.778.337.206.216.322.508.322.813v16.1c0 .305-.116.598-.322.813A1.076 1.076 0 0121.9 24H2.1c-.292 0-.572-.121-.778-.337A1.177 1.177 0 011 22.85V6.75z",
    stroke: "#FC500E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.187 17.675H23v-5.75h-4.813A2.881 2.881 0 0015.3 14.8a2.881 2.881 0 002.887 2.875z",
    stroke: "#FC500E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.188v13.8",
    stroke: "#FC500E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgWallet;